/** @jsx jsx */

import React, { Fragment as _, createContext } from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
//
const { lGrey2 } = colors;

const SortationHeading = ({ children, ...props }) => (
  <div
    css={css`
      margin: 10px 0;
    `}
  >
    {children}
  </div>
);

export default SortationHeading;
